const notificationIdToCtaLookup = {};
export const storeNotification = (notification, actionToCta = {}) => {
  const notificationId = `${notification.id}`;
  notificationIdToCtaLookup[notificationId] = {
    actionToCta,
    meta: notification
  };
};
export const getNotificationCta = (notificationId, action) => {
  const entry = notificationIdToCtaLookup[notificationId];
  if (entry) {
    if (action) {
      return entry.actionToCta[action] ? entry.actionToCta[action] : null;
    }
    return entry.meta.ctaProxyUrl;
  }
  return null;
};
export const getNotificationMeta = notificationId => {
  const entry = notificationIdToCtaLookup[notificationId];
  return entry ? entry.meta : null;
};
export const removeNotification = notificationId => {
  delete notificationIdToCtaLookup[notificationId];
};